'use client'
const isSendBalanceWalletConnector = (walletConnector) => 'createUiTransaction' in walletConnector &&
    typeof walletConnector.createUiTransaction === 'function';

export { isSendBalanceWalletConnector };
